// Only plan-driving features organized by tier trigger
export const FEATURE_TO_PLAN_MAP = {
  // FREE → PROFESSIONAL TRIGGERS
  paid_events: {
    minPlan: 'featured',
    planTier: 1,
    displayName: 'Paid ticketing',
    subText: 'Sell tickets with credit card payments',
    category: 'Free → Professional',
  },
  selling_multiple_events: {
    minPlan: 'featured',
    planTier: 1,
    displayName: 'Showing more than 5 events',
    subText: 'Unlimited active events on your site',
    category: 'Free → Professional',
  },

  // PROFESSIONAL → BUSINESS TRIGGERS
  waitlist: {
    minPlan: 'business',
    planTier: 2,
    displayName: 'Waitlists',
    subText: 'Automatically notify when tickets available',
    category: 'Professional → Business',
  },
  registration_questions: {
    minPlan: 'business',
    planTier: 2,
    displayName: 'Registration questions',
    subText: 'Collect custom info from attendees',
    category: 'Professional → Business',
  },
  automated_rules: {
    minPlan: 'business',
    planTier: 2,
    displayName: 'Automated ticket rules',
    subText: 'Early bird pricing, time-based availability',
    category: 'Professional → Business',
  },
  dedicated_site: {
    minPlan: 'business',
    planTier: 2,
    displayName: 'Dedicated hosted event site',
    subText: 'Your own branded event listing page',
    category: 'Professional → Business',
  },
  analytics_export: {
    minPlan: 'business',
    planTier: 2,
    displayName: 'Analytics and exports',
    subText: 'Sales, check-in, abandoned cart data & CSV export',
    category: 'Professional → Business',
  },

  // BUSINESS → BUSINESS+ TRIGGERS
  whitelabel: {
    minPlan: 'business-plus',
    planTier: 3,
    displayName: 'Full white-label experience',
    subText: 'Remove all TicketSpot branding everywhere',
    category: 'Business → Business+',
  },
  custom_domains: {
    minPlan: 'business-plus',
    planTier: 3,
    displayName: 'Custom domains',
    subText: 'Use your own domain for events and site',
    category: 'Business → Business+',
  },

  // BUSINESS+ → ENTERPRISE TRIGGERS
  multiple_hosts: {
    minPlan: 'enterprise',
    planTier: 4,
    displayName: 'Multiple organizers',
    subText: 'Multi-organizer account structure',
    category: 'Business+ → Enterprise',
  },
  user_submitted_events: {
    minPlan: 'enterprise',
    planTier: 4,
    displayName: 'User-submitted events',
    subText: 'Let others submit events with approval flow',
    category: 'Business+ → Enterprise',
  },
  pos: {
    minPlan: 'enterprise',
    planTier: 4,
    displayName: 'POS ticket printing',
    subText: 'Print tickets on-site with thermal printers',
    category: 'Business+ → Enterprise',
  },
  tracking_links: {
    minPlan: 'business-plus',
    planTier: 3,
    displayName: 'Tracking links',
    subText: 'Track promotional campaign performance',
    category: 'Business → Business+',
  },
} as const;

export type FeatureKey = keyof typeof FEATURE_TO_PLAN_MAP;

export const PLAN_TIER_MAP = {
  free: 0,
  featured: 1,
  business: 2,
  'business-plus': 3,
  enterprise: 4,
} as const;

export const TIER_TO_BILLING_TYPE = {
  0: 'free',
  1: 'featured',
  2: 'business',
  3: 'business-plus',
  4: 'enterprise',
} as const;
